import * as service from './services'
import to from 'await-to-js'
import _ from 'lodash'

const SIZE_LIST = 10

export const state = {
  listResult: [],
  listOrcamento: [],
  sizeTotalOrcamento: 0,
  pageCounte: 0,
  tipoOrcamento: null
}

export const getters = {
  listOrcamento: state => state.listOrcamento,
  listResult: state => state.listResult,
  sizeTotalOrcamento: state => state.sizeTotalOrcamento,
  pageCountOrcamento: state => {
    return Math.ceil(state.sizeTotalOrcamento / SIZE_LIST)
  },
  tipoOrcamento: state => state.tipoOrcamento
}

export const mutations = {
  setListOrcamento (state, payload) {
    state.listOrcamento = payload
  },
  setSizeTotalOrcamento (state, payload) {
    state.sizeTotalOrcamento = payload
  },
  setListResult (state, payload) {
    state.listResult = payload
  },
  setTipoOrcamento (state, payload) {
    state.tipoOrcamento = payload
  }
}

export const actions = {
  setListOrcamento ({commit}, value) {
    commit('setListOrcamento', value)
  },
  setTipoOrcamento ({commit}, value) {
    commit('setTipoOrcamento', value)
  },
  async findOrcamento ({commit, dispatch}, filtro) {
    delete filtro.outroServico
    dispatch('setLoading', true)
    const [error, response = { data: [] }] = await to(service.getOrcamento(filtro))
    dispatch('setLoading', false)
    if (error) {
      throw error
    }
    commit('setListResult', response.data)
    commit('setSizeTotalOrcamento', response.data.length)
    dispatch('handleSortOrcamento', {})
    dispatch('handlePagination', {page: 1, pageSize: 10})
    return response.data
  },

  handlePagination ({getters, commit}, data) {
    const page = data.page ? data.page : 1
    const pageSize = data.pageSize ? data.pageSize : 10

    if (getters.sizeTotalOrcamento === 0) {
      commit('setListOrcamento', [])
      return false
    }

    if (getters.sizeTotalOrcamento > pageSize) {
      let first = (page - 1) * pageSize
      commit('setListOrcamento', getters.listResult.slice(first, first + pageSize))
    } else {
      commit('setListOrcamento', getters.listResult)
    }
  },

  handleSortOrcamento ({getters, dispatch, commit}, config) {
    console.log('handle sort', config)
    const field = config.field ? config.field : 'rede.nomeRede'
    const order = config.order ? config.order : 'asc'
    const page = config.page ? config.page : 1

    const property = []
    property.push(field)

    if (order === 'desc') {
      commit('setListResult', _.orderBy(getters.listResult, property, ['desc']))
    } else {
      commit('setListResult', _.orderBy(getters.listResult, field))
    }
    dispatch('handlePagination', {page})
  }

}



// WEBPACK FOOTER //
// ./src/store/orcamento/index.js